import { render, staticRenderFns } from "./CustomPill.vue?vue&type=template&id=50f0c030&scoped=true"
import script from "./CustomPill.vue?vue&type=script&lang=js"
export * from "./CustomPill.vue?vue&type=script&lang=js"
import style0 from "./CustomPill.vue?vue&type=style&index=0&id=50f0c030&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f0c030",
  null
  
)

export default component.exports